import z from "zod";

/**
 * FornecedorBancoSchema
 */

export const FornecedorBancoSchema = z.object({
  tipoConta: z.coerce.number().default(0),
  banco: z.string().default(''),
  agencia: z.string().default(''),
  conta: z.string().default(''),
  contaDigito: z.string().default(''),
  operacao: z.string().default(''),
  favorecido: z.string().default(''),
  cpfCnpj: z.string().default(''),
  pix: z.string().default(''),
});

/**
 * FornecedorBancoForm
 */

export type FornecedorBancoForm = z.infer<typeof FornecedorBancoSchema>;